// AcidIsland marketing page — DOM 1:1 from the legacy skyland page
// (src/app/(portal)/skyland/page.tsx), rebranded 空岛→海岛. Renders into
// #root without any shell wrapper. acidisland.css is loaded via <link> in
// the HTML template. acidisland.js is loaded imperatively after mount.
// The #f-p1 hero block uses dangerouslySetInnerHTML because React 19 refuses
// to serialize javascript: URLs (matching the Next.js raw-HTML island).

import { useEffect } from "react";

const CURRENT_YEAR = new Date(
  Date.now() + 8 * 60 * 60 * 1000,
).getUTCFullYear();

const HERO_HTML = `
            <h1>
                <span>${CURRENT_YEAR - 2011}年老牌优秀公益服</span><br>
                <b class="c-t">随便MC~</b>海岛服<br>
            </h1>
            <a class="btn head-btn" href="/">返回首页</a>
            <a class="btn head-btn" id="btn-intro" href="javascript:">查看介绍</a>
            <a class="btn head-btn" id="btn-join" href="javascript:">加入服务器</a>`;

export function AcidIslandPage() {
  // Inject acidisland.js imperatively after mount — same pattern as
  // homepage's useLegacyScripts. acidisland.js wires the #btn-intro /
  // #btn-join click handlers and other interactivity.
  useEffect(() => {
    const el = document.createElement("script");
    el.src = "/static/js/acidisland.js";
    el.async = false;
    document.body.appendChild(el);
    return () => {
      el.remove();
    };
  }, []);

  return (
    <>
      <div id="f-f1">
        <div id="f-p1" dangerouslySetInnerHTML={{ __html: HERO_HTML }} />
      </div>
      <div id="f-f2" className="titlebar">
        <p>重新设计的海岛插件</p>
        <p>给你一个全新的海岛游戏体验</p>
      </div>
      <div id="f-f3" className="section">
        <p>
          在？<span>来刷个沙？</span>
        </p>
        <h2>每个岛屿独立下界/末地世界</h2>
        <p>
          重力方块<b className="c-t">随便</b>刷
        </p>
        <video
          id="f-v3"
          src="/static/acidisland/img/p2.mp4"
          autoPlay
          loop
          muted
        ></video>
      </div>
      <div id="f-f4" className="section">
        <p>
          在？<span>来跑个酷？</span>
        </p>
        <h2>网格生存资源世界</h2>
        <p>
          稀有资源<b className="c-t">随便</b>挖
        </p>
      </div>
      <div id="f-f5" className="section">
        <p>
          在？<span>来打个龙？</span>
        </p>
        <h2>海岛公共末影龙副本</h2>
        <p>
          龙蛋龙头<b className="c-t">随便</b>拿*
        </p>
        <div className="footnote">
          * 指副本中杀死末影龙必定掉落龙蛋，及可通过挑战系统无限获取龙头物品
        </div>
      </div>
      <div id="f-f6" className="showcase">
        <p>我还想要...</p>
        <div>
          <img src="/static/acidisland/img/p5-1.png" />
          <p>更多的漏斗</p>
          <div></div>
          <p>岛屿漏斗上限可增加</p>
        </div>
        <div>
          <img src="/static/acidisland/img/p5-2.png" />
          <p>刷守卫者</p>
          <div></div>
          <p>
            通过建造刷怪设施，<br />
            在水中刷新守卫者/远古守卫者
          </p>
        </div>
        <div>
          <img src="/static/acidisland/img/p5-3.png" />
          <p>刷潜影贝</p>
          <div></div>
          <p>
            满足条件的刷怪区域<br />
            有可能生成潜影贝
          </p>
        </div>
      </div>
      <div id="f-f7" className="titlebar">
        <p>开放自由的游戏环境</p>
        <p>做你想做的一切*</p>
        <div className="footnote">
          * 不违反{" "}
          <a
            target="_blank"
            href="https://wiki.evermc.com/%E7%8E%A9%E5%AE%B6wiki/%E7%A9%BA%E5%B2%9B%E6%9C%8D/%E7%A9%BA%E5%B2%9B%E7%94%A8%E6%88%B7%E5%8D%8F%E8%AE%AE_eula"
          >
            随便MC海岛守则(EULA)
          </a>{" "}
          的前提下
        </div>
      </div>
      <div id="f-f8" className="section nospan">
        <p>服务器禁止红石怎么办？</p>
        <p>来随便MC海岛！</p>
        <h2>
          高频红石<b className="c-t">随便</b>造
        </h2>
      </div>
      <div id="f-f9" className="section nospan">
        <p>还要造挂机池？</p>
        <p>来随便MC海岛！</p>
        <h2>
          <b className="c-t">随便</b>挂机不被T
        </h2>
        <video
          id="f-v9"
          src="/static/acidisland/img/p9.mp4"
          autoPlay
          loop
          muted
        ></video>
      </div>
      <div id="f-f10" className="titlebar">
        <p>{CURRENT_YEAR - 2011}年老牌公益服</p>
        <p>就是这么稳定</p>
      </div>
      <div id="f-f11" className="section nospan">
        <p>公益服了解一下？</p>
        <h2>点一下 玩一年</h2>
        <p>游戏不花一分钱</p>
        <h2>还在等什么？赶快来加入吧！</h2>
        <p>
          <a
            className="btn btn-qq"
            target="_blank"
            href="http://shang.qq.com/wpa/qunwpa?idkey=3b2e0e7ac00293e6605c06c9e222625b7c79b916e599e18d4a61b4cb487566e4"
          ></a>
          <a className="btn btn-sign" href="/user/"></a>
        </p>
      </div>
      <footer>
        <span>
          &copy;2011~{CURRENT_YEAR} <a href="/">随便MC</a>
        </span>
        <span>
          <a href="/terms">服务条款</a>
        </span>
        <span>
          <a href="/privacy">隐私协议</a>
        </span>
        <span>
          <a
            href="http://beian.miit.gov.cn"
            className="navbar-link"
            target="_blank"
            rel="noreferrer"
          >
            京ICP备18035465号
          </a>
        </span>
      </footer>
    </>
  );
}
